// React Query queryKey SSOT for AI chat.
// ユーザーIDをキーに含める: ログアウト直後に別ユーザーがログインした場合に
// キャッシュされた会話が見えないようにする（notifications と同じ理由）。

export const chatQueryKeys = {
  all: ['chat'] as const,
  usage: (userId: string) => ['chat', userId, 'usage'] as const,
  conversation: (userId: string, conversationId: string) =>
    ['chat', userId, 'conversation', conversationId] as const,
  home: (userId: string, contextEventId: string | null) =>
    ['chat', userId, 'home', contextEventId ?? ''] as const,
  breakdown: (userId: string) => ['chat', userId, 'breakdown'] as const,
  conversations: (userId: string) => ['chat', userId, 'conversations'] as const,
  comments: (userId: string, eventId: string) => ['chat', userId, 'comments', eventId] as const,
} as const;
